import {
  Box,
  Button,
  Flex,
  FormLabel,
  Input,
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import UrlShortenerService, { ICreateUrlShortenerPayload } from '../../../services/UrlShortener/UrlShortenerService'

interface IUrlShortenerFormModalProps {
  isOpen: boolean
  onClose: () => void
  onCreated: () => void
}

export default function UrlShortenerFormModal({ isOpen, onClose, onCreated }: IUrlShortenerFormModalProps) {
  const toast = useToast()
  const [saving, setSaving] = useState(false)
  const [form, setForm] = useState<ICreateUrlShortenerPayload>({
    title: '',
    original_url: '',
    short_path: ''
  })
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})

  const handleSave = async () => {
    setSaving(true)
    setFormErrors({})
    try {
      await UrlShortenerService.create(form)
      toast({ title: 'URL curta criada com sucesso', status: 'success', duration: 3000, isClosable: true })
      setForm({ title: '', original_url: '', short_path: '' })
      onCreated()
      onClose()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      if (err.response?.status === 422) setFormErrors(err.response.data.errors)
      else toast({ title: 'Erro ao criar URL curta', status: 'error', duration: 3000, isClosable: true })
    } finally {
      setSaving(false)
    }
  }

  return (
    <ChakraModal isOpen={isOpen} onClose={onClose} size="md" isCentered scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Criar URL Curta</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" gap={3}>
            <Box>
              <FormLabel>Título</FormLabel>
              <Input
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
                disabled={saving}
                maxLength={255}
              />
              {formErrors.title && <Text color="red.500">{formErrors.title}</Text>}
            </Box>
            <Box>
              <FormLabel>URL Original</FormLabel>
              <Input
                value={form.original_url}
                onChange={(e) => setForm({ ...form, original_url: e.target.value })}
                disabled={saving}
                type="url"
              />
              {formErrors.original_url && <Text color="red.500">{formErrors.original_url}</Text>}
            </Box>
            <Box>
              <FormLabel>Path (opcional)</FormLabel>
              <Input
                value={form.short_path}
                onChange={(e) => setForm({ ...form, short_path: e.target.value })}
                disabled={saving}
                maxLength={255}
              />
              {formErrors.short_path && <Text color="red.500">{formErrors.short_path}</Text>}
            </Box>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="magenta" mr={3} onClick={handleSave} isLoading={saving}>
            Criar
          </Button>
          <Button variant="ghost" onClick={onClose} disabled={saving}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </ChakraModal>
  )
}
